import { FC, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { InputField } from 'src/components/shared/InputBlock';
import { isObjectEmpty } from 'src/helpers';
import { IEmailTemplate, useUpdateEmailTemplatesMutation } from 'src/redux/services/settings';
import { ViewEmailTemplate } from '../../applications/old/ViewEmailTemplate';
import { SidePanel } from '../../sidePanel/SidePanel';
import styles from './EditEmailTemplates.module.css';

interface IEditEmailTemplateProps {
  isOpen: boolean;
  onClose: () => void;
  template?: IEmailTemplate;
}

export const EditEmailTemplate: FC<IEditEmailTemplateProps> = ({ isOpen, onClose, template }) => {
  const [editEmailTemplate] = useUpdateEmailTemplatesMutation();

  const methods = useForm<IEmailTemplate>({
    mode: 'all',
  });
  const {
    handleSubmit,
    formState: { dirtyFields },
    reset,
    register,
    watch,
  } = methods;
  const watchContent = watch('content');

  useEffect(() => {
    reset(template);
  }, [isOpen]);

  const handleSave = async (data: IEmailTemplate) => {
    //Отправляем только принимаемые поля
    const { id, action, ...body } = data;

    try {
      await editEmailTemplate({
        action,
        body,
      }).unwrap();
      onClose();
    } catch (error) {
      console.error('Failed to save the template:', error);
    }
  };

  return (
    <>
      <SidePanel
        onClose={onClose}
        isOpen={isOpen}
        title={`Редактировать шаблон письма
              ${template ? `'${template.title}'` : ''}`}
        description={`Измените шаблон письма для события ${template ? template.action : ''}`}
        isNoBackdrop
        handleConfirm={handleSubmit(handleSave)}
        disabledButtonConfirm={isObjectEmpty(dirtyFields)}
      >
        <FormProvider {...methods}>
          <form className={styles.wrapper}>
            <InputField label={'Название шаблона'} {...register('title')} />
            <InputField label={'Тема письма'} {...register('subject')} />
            <div className={styles.preview}>
              <ViewEmailTemplate content={watchContent} />
            </div>
            <InputField label={'Содержимое письма'} {...register('content')} rows={10} />
          </form>
        </FormProvider>
      </SidePanel>
    </>
  );
};
